import {createReducer, on} from "@ngrx/store";
import * as SharedActions from './shared.actions'
import {DocumentScanningStatus} from "../models/document-scanning.models";

export const SHARED_FEATURE_KEY = 'shared';

export interface SharedState {
  skipDocumentScanning: boolean;
  documentScanningStatus: DocumentScanningStatus,
  shortUrl: string;
  autoFill: boolean;
  errors: string[];
}

export const INITIAL_STATE: SharedState = {
  skipDocumentScanning: false,
  documentScanningStatus: DocumentScanningStatus.Pending,
  shortUrl: '',
  autoFill: false,
  errors: []
}

export const sharedReducer = createReducer(
  INITIAL_STATE,
  on(SharedActions.scanningDocument, (state) => ({
    ...state,
    documentScanningStatus: DocumentScanningStatus.InProgress
  })),
  on(SharedActions.scanDocumentUsingWebServiceSuccess, (state) => ({
    ...state,
    documentScanningStatus: DocumentScanningStatus.Success,
    autoFill: true,
  })),
  on(SharedActions.scanDocumentUsingWebServiceError, (state, {errors}) => ({
    ...state,
    documentScanningStatus: DocumentScanningStatus.Error,
    errors: errors
  })),
  on(SharedActions.getShortUrlSuccess, (state, {shortUrl}) => ({
    ...state,
    shortUrl: shortUrl
  })),
  on(SharedActions.skipDocumentScanning, (state) => ({
    ...state,
    skipDocumentScanning: true
  })),
  on(SharedActions.resetSkipDocumentScanning, (state) => ({
    ...state,
    skipDocumentScanning: false
  })),
  on(SharedActions.resetAutoFillForm, (state) => ({
    ...state,
    autoFill: false,
    documentScanningStatus : DocumentScanningStatus.Pending
  })),
)

export function reducer(state, action) {
  return sharedReducer(state, action);
}
